import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import moment from 'moment';
import {
  LineChartWrapper,
  Footer,
  Section1,
  Section2,
  Section3,
  ChartLinesWrapper,
  Wrapper,
  ChartLine,
  ChartPoint,
  Position
} from './line-chart.styled';
import { attachSuffix } from '../../helpers/utils';
import HoverContext from './hover-context/hover-context';

const getColor = (score) => {
  if (score < 50) {
    return '#900012';
  } else if (score > 85) {
    return '#008902';
  }

  return '#2452bb';
};

const RenderChartLines = (i18n, results) => {
  const [showCallOutMenu, setCallOutMenu] = useState(false);
  const [currentHoveredPoint, setCurrentHoveredPoint] = useState(0);

  const TOTAL_CHART_COLUMNS = 10;
  const COLUMN_WIDTH = 38;
  const COLUMN_HEIGHT = 130;
  const TOTAL_OFFSET = 5;
  const Columns = [];

  const showCallOut = (e, currentIndex) => {
    if (parseInt(e.target.getAttribute('data-index'), 10) === currentIndex) {
      setCallOutMenu(true);
      setCurrentHoveredPoint(currentIndex);
    }
  };

  const hideCallOut = () => {
    setCallOutMenu(false);
  };

  const sortedResults = results.sort((a, b) => a.attempts - b.attempts);

  for (let i = 1; i <= TOTAL_CHART_COLUMNS; i++) {
    const { score, completionDate } =
      i <= results.length && sortedResults[i - 1];
    const nextScore = i <= results.length && sortedResults[i]?.score;
    const currentPosition = (score / 100) * COLUMN_HEIGHT;
    const nextPosition = (nextScore / 100) * COLUMN_HEIGHT;

    Columns.push(
      <ChartLinesWrapper key={`${score}_${i}`}>
        <ChartLine>
          {/* Plotted points on the chart should be equal to the number of results */}
          {i <= results.length && (
            <>
              <ChartPoint
                data-testid="chartPoint"
                data-index={i}
                position={currentPosition}
                color={getColor(score)}
                role="button"
                tabIndex="-1"
                onMouseEnter={(e) => showCallOut(e, i)}
                onMouseLeave={hideCallOut}
              >
                <HoverContext
                  data-testid="hover-context"
                  show={showCallOutMenu && i === currentHoveredPoint}
                  date={moment(completionDate).format('DD MMM YYYY')}
                />
              </ChartPoint>
              {/* Lines between the plotted lines should be one less than the points */}
              {i <= results.length - 1 && (
                <svg height="160" width="100">
                  <defs>
                    <linearGradient
                      id="e"
                      x1="0"
                      y1={COLUMN_HEIGHT - currentPosition + TOTAL_OFFSET}
                      x2={COLUMN_WIDTH}
                      y2={COLUMN_HEIGHT - nextPosition + TOTAL_OFFSET}
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor={getColor(score)} offset="0" />
                      <stop stopColor={getColor(nextScore)} offset="1" />
                    </linearGradient>
                  </defs>
                  <line
                    x1="0"
                    y1={COLUMN_HEIGHT - currentPosition + TOTAL_OFFSET}
                    x2={COLUMN_WIDTH}
                    y2={COLUMN_HEIGHT - nextPosition + TOTAL_OFFSET}
                    stroke="url(#e)"
                    strokeWidth="3"
                  />
                </svg>
              )}
            </>
          )}
        </ChartLine>
        <Position enabled={i <= results.length}>
          {attachSuffix(i, i18n)}
        </Position>
      </ChartLinesWrapper>
    );
  }
  return Columns;
};

const LineChart = ({ i18n, results }) => {
  return (
    <>
      <Wrapper data-testid="lineChart">
        {RenderChartLines(i18n, results)}
      </Wrapper>
      <LineChartWrapper>
        <Section1 data-testid="85to100">85-100%</Section1>
        <Section2 data-testid="50to85">50-85%</Section2>
        <Section3 data-testid="lessThan50">{`<50%`}</Section3>
        <Footer data-testid="attempt">
          {i18n._(t('chart.attempt')`Attempt`)}
        </Footer>
      </LineChartWrapper>
    </>
  );
};

LineChart.propTypes = {
  results: PropTypes.array,
  i18n: PropTypes.object
};

LineChart.defaultProps = {
  results: []
};

export default LineChart;



// WEBPACK FOOTER //
// ./components/line-chart/line-chart.js